import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Model } from 'src/app/app.model';
import { Subscription } from 'src/app/subscription/subscription.model';
import { SubscriptionService } from 'src/app/subscription/subscription.service';
import { WorkflowCspService } from '../workflow-csp.service';
import { firstValueFrom } from 'rxjs';
import { WorkflowComponent } from '../../workflow.component';
import { SaleOrder } from 'src/app/buy/buy.model';
import { tariffFlatNames } from 'src/app/tariff/tariff.model';

@Component({
    selector: 'app-workflow-csp-one-tariff-order-cancel',
    templateUrl: './workflow-csp-one-tariff-order-cancel.component.html',
    standalone: false
})
export class WorkflowCspOneTariffOrderCancelComponent extends WorkflowComponent implements OnInit {

    public subscription: Subscription;

    constructor(
        protected route: ActivatedRoute,
        protected m: Model,
        protected router: Router,
        protected subscriptionService: SubscriptionService,
        protected workflowCsp: WorkflowCspService
    ) {
        super();
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.setStep('order-cancel');
        if (!this.applianceId) {
            return;
        }

        this.subscriptionService.getSubscriptionDetails(+this.applianceId).subscribe({
            next: (r) => {
                this.subscription = Subscription.fromJson(r);
                this.applianceId = this.subscription.appliance_id;
            },
            error: (err) => {
                console.error('Failed to load subscription:', err);
            }
        });
    }

    private setStep(step: string) {
        this.step = step;
    }

    onBack() {
        this.resetWorkflow();
    }

    async onConfirm() {
        try {
            const orderWithTariff = this.subscription?.orders?.find(order =>
                order?.lines?.some(line => tariffFlatNames.includes(line?.product))
            );

            if (orderWithTariff) {
                await firstValueFrom(this.workflowCsp.oneApplianceCancelTariffOrder(orderWithTariff.name));
            }

            this.resetWorkflow();
        } catch (e) {
            console.error('Cancel tariff order failed', e);
            this.resetWorkflow();
        }
    }
}
